// components/TopInfoBar.tsx
import { Globe, UserRound, ChevronDown } from "lucide-react";

export default function TopInfoBar({ onOpen }: { onOpen?: () => void }) {
  return (
    <div className="bg-[#616161] max-w-6xl w-full text-white text-sm px-4 py-1 flex justify-end items-center gap-4">
      {/* Country Selector */}
      <div className="flex items-center gap-1 cursor-pointer" onClick={onOpen}>
        <Globe className="w-4 h-4" />
        <span>US</span>
        <ChevronDown className="w-3 h-3" />
      </div>

      {/* Divider */}
      <span className="text-white">|</span>

      {/* Log In */}
      <div className="flex items-center gap-1 cursor-pointer" onClick={onOpen}>
        <UserRound className="w-4 h-4" />
        <span>Log In</span>
      </div>
    </div>
  );
}
